import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Loader from "../components/shared/Loader/Loader";
const Home = lazy(() => import("../pages/Home"));
const Login = lazy(() => import("../pages/Login"));
const SignUp = lazy(() => import("../pages/SignUp"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const Products = lazy(() => import("../pages/Products"));
const Solutions = lazy(() => import("../pages/Solutions"));
const Support = lazy(() => import("../pages/Support"));
const Developers = lazy(() => import("../pages/Developers"));
const Companies = lazy(() => import("../pages/Companies"));
const Pricing = lazy(() => import("../pages/Pricing"));
const AboutUs = lazy(() => import("../pages/AboutUs"));
const LeadershipTeam = lazy(() => import("../pages/LeadershipTeam"));
const GettingStarted = lazy(() => import("../pages/GettingStarted"));
const Chatbots = lazy(() => import("../pages/Chatbots"));
const TextToSpeech = lazy(() => import("../pages/TextToSpeech"));
const CodeReview = lazy(() => import("../pages/CodeReview"));
const Healthcare = lazy(() => import("../pages/Healthcare"));
const ImageAnalysis = lazy(() => import("../pages/ImageAnalysis"));
const DocumentAnalysis = lazy(() => import("../pages/DocumentAnalysis"));
const NoiseCancelling = lazy(() => import("../pages/NoiseCancelling"));
const FraudDetector = lazy(() => import("../pages/FraudDetector"));
const TextAnalytics = lazy(() => import("../pages/TextAnalytics"));
const Forecast = lazy(() => import("../pages/Forecast"));
const PersonalAssistant = lazy(() => import("../pages/PersonalAssistant"));
const PersonalizedRecommendations = lazy(() =>
  import("../pages/PersonalizedRecommendations")
);
const EnterpriseSearch = lazy(() => import("../pages/EnterpriseSearch"));
const API = lazy(() => import("../pages/API"));
const PlatformOverview = lazy(() => import("../pages/PlatformOverview"));
const ExploreOurTools = lazy(() => import("../pages/ExploreOurTools"));
const TranslateAi = lazy(() => import("../pages/TranslateAi"));
const Learn = lazy(() => import("../pages/Learn"));
const Documentation = lazy(() => import("../pages/Documentation"));
const WhatsNew = lazy(() => import("../pages/WhatsNew"));
const Careers = lazy(() => import("../pages/Careers"));
const Blog = lazy(() => import("../pages/Blog"));
const News = lazy(() => import("../pages/News"));
const TermsOfService = lazy(() => import("../pages/TermsOfService"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const ReadMore = lazy(() => import("../pages/ReadMore"));

export default function Default() {
  return (
    <Suspense fallback={Loader()}>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/signup" component={SignUp} />
        <Route exact path="/contact" component={ContactUs} />
        <Route exact path="/products" component={Products} />
        <Route exact path="/solutions" component={Solutions} />
        <Route exact path="/support" component={Support} />
        <Route exact path="/developers" component={Developers} />
        <Route exact path="/companies" component={Companies} />
        <Route exact path="/pricing" component={Pricing} />
        <Route exact path="/about-us" component={AboutUs} />
        <Route exact path="/leadership_team" component={LeadershipTeam} />
        <Route exact path="/gettingstarted" component={GettingStarted} />
        <Route exact path="/chatbots" component={Chatbots} />
        <Route exact path="/texttospeech" component={TextToSpeech} />
        <Route exact path="/code-review" component={CodeReview} />
        <Route exact path="/healthcare" component={Healthcare} />
        <Route exact path="/imageanalysis" component={ImageAnalysis} />
        <Route exact path="/documentanalysis" component={DocumentAnalysis} />
        <Route exact path="/noisecancelling" component={NoiseCancelling} />
        <Route exact path="/frauddetector" component={FraudDetector} />
        <Route exact path="/textanalytics" component={TextAnalytics} />
        <Route exact path="/forecast" component={Forecast} />
        <Route exact path="/personalassistant" component={PersonalAssistant} />
        <Route
          exact
          path="/personalizedrecommendations"
          component={PersonalizedRecommendations}
        />
        <Route exact path="/enterprisesearch" component={EnterpriseSearch} />
        <Route exact path="/api" component={API} />
        <Route exact path="/platformoverview" component={PlatformOverview} />
        <Route exact path="/explore-our-tools" component={ExploreOurTools} />
        <Route exact path="/translateai" component={TranslateAi} />
        <Route exact path="/learn" component={Learn} />
        <Route exact path="/documentation" component={Documentation} />
        <Route exact path="/whats_new" component={WhatsNew} />
        <Route exact path="/careers" component={Careers} />
        <Route exact path="/blog" component={Blog} />
        <Route exact path="/news" component={News} />
        <Route exact path="/termsofservice" component={TermsOfService} />
        <Route exact path="/privacypolicy" component={PrivacyPolicy} />
        <Route path="/card-details/:id" exact component={ReadMore} />
      </Switch>
    </Suspense>
  );
}
